'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RegulatoryRecord = undefined;

var _immutable = require('immutable');

/** Model */


/** Logo model */


/** Regulatory types */
var Logo = (0, _immutable.Record)({
    title: '',
    url: '',
    target: '_self',
    className: '',
    nofollow: true
});
var RegulatoryRecord = exports.RegulatoryRecord = (0, _immutable.Record)({
    responsibleGambling: '',
    logos: (0, _immutable.List)(),
    cookieInfo: '',
    license: ''
});

/**
 * Transforms a logo entity into an immutable Logo Record
 * @param {LogosListType} bag The list of logo records compiled so far
 * @param {Object} logo The logo entity as returned by the CMS
 * @returns {LogosListType} The list of logo records
 */
var transformLogosToModel = function transformLogosToModel(bag, logo) {
    return bag.push(new Logo(logo));
};

/**
 * Transforms the Squiz response into a data model
 * @param {CMSRegulatoryType} data The data response from Squiz
 * @returns {RegulatoryRecordType} The data model
 */
var transformRegulatoryData = function transformRegulatoryData(_ref) {
    var responsibleGambling = _ref.responsibleGambling,
        logos = _ref.logos,
        cookieInfo = _ref.cookieInfo,
        license = _ref.license;
    return new RegulatoryRecord({
        responsibleGambling: responsibleGambling,
        logos: logos.reduce(transformLogosToModel, (0, _immutable.List)()),
        cookieInfo: cookieInfo,
        license: license
    });
};

exports.default = transformRegulatoryData;
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/regulatory/model.js
// module id = 257
// module chunks = 0